// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Ordering was successful',
    description: '<div>Thank you for ordering and travel with Kolumbus.</div><div>You will receive an email with your ticket shortly.</div><h5>Don\'t close this page yet.</h5><div>First check that you have received the email with the ticket, also check your spam folder.</div><div>Below you have the option to download the ticket as an additional option.</div>',
    download: 'Download ticket'
}
